module["exports"] = [
  "?#? #?#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IND/address/postcode.js
 ** module id = 532
 ** module chunks = 0
 **/